import React from "react";
import { BottomBar, Button, Container, Pagination, ResponsiveFields, Searchbox, AddGuest, EditPassport, EditNationalId, Toast, Dialog } from "../../../../../Components";
import { useState } from "react";
import useFetch from "../../../../../Hooks/useFetch";
import apis from "../../../../../Utils/apis";
import { StampToDate } from "../../../../../Utils/utils";
import { deleteRequest } from "../../../../../Utils/axios";
import { FaTrashAlt } from "react-icons/fa";

function Guests() {
	const initial = { guests: [], count: 0, pages: 0 };
	const [Query, setQuery] = useState({ search: "", page: 1 });
	const { response, reload, loading } = useFetch(apis.getAllGuests, Query, initial);
	const [ConfirmDialog, setConfirmDialog] = useState();

	const deleteGuest = () => {
		deleteRequest(`guests/${ConfirmDialog.id}`, {}, (r, e) => {
			if (r) {
				Toast.success(`Guest deleted`);
				setConfirmDialog();
				reload();
			} else if (e) {
				Toast.handleError(e);
			}
		});
	};

	return (
		<>
			<BottomBar>
				<div className="w-full flex-center-between">
					<div className="align-center gap-x-4">
						<AddGuest onReload={reload} />
						<h5>{response.guests?.length} Guests</h5>
					</div>
					<div>
						<Pagination active={Query.page} total={response.pages} onChange={(page) => setQuery({ ...Query, page })} />
					</div>
				</div>
			</BottomBar>
			<div className="mt-6 flex w-full">
				<Searchbox className="w-full sm:w-96" placeholder="Search Guests" cmd="s" onChange={(search) => setQuery({ ...Query, search })} />
			</div>
			<Container variant="outlined" className="mt-4 mb-20 !p-2 sm:!p-4">
				{loading ? (
					<div className="p-4 text-sm text-secondary">Loading...</div>
				) : (
					<ResponsiveFields
						variant="cards"
						columnsClassName="sm:grid-cols-2 lg:grid-cols-3"
						items={response.guests || []}
						getKey={(g, i) => `${g?.id || ""}-${i}`}
						columns={[
							{ key: "name", label: "Guest Name", valueClassName: "font-bold break-words", render: (g) => `${g.fName} ${g.lName}` },
							{ key: "email", label: "Email", valueClassName: "break-words", render: (g) => g.email || "-" },
							{ key: "phone", label: "Phone", valueClassName: "whitespace-nowrap", render: (g) => g.phone || "-" },
							{ key: "gender", label: "Gender", valueClassName: "whitespace-nowrap", render: (g) => g.gender || "-" },
							{ key: "dob", label: "Date of Birth", valueClassName: "whitespace-nowrap", render: (g) => (g.dob ? StampToDate(g.dob) : "-") },
							{
								key: "passport",
								label: "Passport",
								render: (g) => <EditPassport reload={reload} identification={g.identification} guestId={g.id} photo={g.photo} />,
							},
							{
								key: "nationalId",
								label: "National ID",
								render: (g) => <EditNationalId reload={reload} identification={g.identification} guestId={g.id} />,
							},
							{
								key: "actions",
								label: "Actions",
								render: (g) => (
									<Button onClick={() => setConfirmDialog(g)} variant="danger" className="btn-xs w-full sm:w-auto">
										<FaTrashAlt />
									</Button>
								),
							},
						]}
					/>
				)}
			</Container>
			<Dialog variant="danger" open={ConfirmDialog} title="Delete Guest" description="Are you sure you want to delete this guest, this is an irreversible action." submitLabel="Delete" onSubmit={deleteGuest} onClose={setConfirmDialog} />
		</>
	);
}

export default Guests;
